/** Match known transport failures, not every TypeError or provider failure. */
export function isConnectionError(error: unknown): boolean {
  const value = error as { name?: string; status?: number; message?: string } | null;
  return (value?.name === 'AuthRetryableFetchError' && !value.status)
    || (error instanceof TypeError && /^(failed to fetch|load failed|networkerror(?: when attempting to fetch resource\.)?)$/i.test(error.message.trim()));
}

export function isRetryableReadError(error: unknown): boolean {
  const status = Number((error as { status?: number } | null)?.status);
  return isConnectionError(error) || status === 408 || status === 429 || (status >= 500 && status <= 599);
}
